class TeamCard extends HTMLElement {
  constructor(){
    super();

    this.slides =  this.querySelectorAll('.container-img');
    this.modal =   this.querySelector('.modal');
    this.close =  this.querySelector('.close-modal');

    this.tiny;
  }

  connectedCallback(){
    
    this.close.addEventListener('click', this.onCloseClick.bind(this));
    this.slides.forEach(elm => elm.addEventListener('click', this.onSliderClick.bind(this)));
  }

  onCloseClick(evtn){
    evtn.preventDefault();
    this.modal.classList.remove('active-modal');
    this.tiny.destroy();
  }

  onSliderClick(evtn){
    evtn.preventDefault();
    this.modal.classList.add('active-modal');

    this.index = evtn.currentTarget.dataset.index;
    this.tiny = tns({
      container: this.querySelector(".modal-content-team"),
      items: 1,
      swipeAngle: false,
      speed: 400,
      controlsContainer: this.querySelector(".modal-nav"),
      startIndex:  this.index,
      mouseDrag: true
    });

    this.tiny;
  }

}
customElements.define('team-cards',TeamCard);